export default "__VITE_ASSET__BFk$UAn7__"